import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { X } from "lucide-react";
import api, { resolveImg } from "@/lib/api";
import { track } from "@/lib/analytics";
import { SiteLayout } from "@/components/site/SiteLayout";

const CATEGORIES = ["all", "Skin Fade", "Mid Fade", "Low Fade", "High Fade", "Beard", "Line Up"];

export default function Portfolio() {
  const [category, setCategory] = useState("all");
  const [active, setActive] = useState(null);
  useEffect(() => { track("page_view", { page: "portfolio" }); }, []);

  const { data } = useQuery({
    queryKey: ["portfolio", category],
    queryFn: async () => (await api.get("/catalog/portfolio", { params: category === "all" ? {} : { category } })).data,
  });
  const items = data || [];

  return (
    <SiteLayout>
      <div className="mx-auto max-w-7xl px-6 py-10">
        <h1 className="font-display text-4xl font-bold uppercase tracking-tighter sm:text-5xl">My Work</h1>
        <p className="mt-2 text-zinc-400">A gallery of real cuts — fades, tapers, beards and line ups.</p>

        <div className="mt-6 flex flex-wrap gap-2">
          {CATEGORIES.map((c) => (
            <button key={c} data-testid={`portfolio-filter-${c}`} onClick={() => setCategory(c)}
              className={`rounded-full border px-4 py-1.5 text-sm transition-colors ${
                category === c ? "border-[#DCA846] bg-[#DCA846] text-black" : "border-white/15 text-zinc-300 hover:border-[#DCA846]/50"
              }`}>
              {c === "all" ? "All" : c}
            </button>
          ))}
        </div>

        {items.length === 0 ? (
          <div className="py-24 text-center text-zinc-500">No photos in this category yet.</div>
        ) : (
          <div className="mt-8 columns-2 gap-4 sm:columns-3 lg:columns-4 [&>*]:mb-4">
            {items.map((p) => (
              <button key={p.id} data-testid={`portfolio-item-${p.id}`} onClick={() => setActive(p)}
                className="block w-full overflow-hidden rounded-lg border border-white/10 break-inside-avoid group">
                <img src={resolveImg(p.image)} alt={p.title} loading="lazy"
                  className="w-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </button>
            ))}
          </div>
        )}
      </div>

      {active && (
        <div data-testid="portfolio-lightbox" onClick={() => setActive(null)}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-6 backdrop-blur-sm">
          <button className="absolute top-6 right-6 text-white"><X className="h-7 w-7" /></button>
          <img src={resolveImg(active.image)} alt={active.title} className="max-h-[85vh] max-w-full rounded-lg border border-white/10" />
        </div>
      )}
    </SiteLayout>
  );
}
